import * as PIXI from "pixi.js";
import SpriteGenerator from "../generators/SpriteGenerator";
import { convertSize } from "../utils";

export function loadTimer({ parent, texture }) {
  // const timerContainer = new PIXI.particles.ParticleContainer();
  const timerContainer = new PIXI.Container();
  timerContainer.zIndex = 1;

  const timerBoard = SpriteGenerator({
    width: convertSize(88, window.innerWidth),
    height: convertSize(88, window.innerWidth),
    texture
  });

  const timerText = new PIXI.Text("0", {
    fontFamily:
      "Gotham Bold, -apple-system, system-ui, BlinkMacSystemFont, Tahoma, Segoe UI, Helvetica",
    fontSize: convertSize(30, window.innerWidth),
    lineHeight: convertSize(33, window.innerWidth),
    fill: 0xffffff
  });
  timerText.x = convertSize(44, window.innerWidth);
  timerText.y = convertSize(41, window.innerWidth);
  timerText.anchor.set(0.5);

  timerContainer.addChild(timerBoard);
  timerContainer.addChild(timerText);
  parent.addChild(timerContainer);

  return { timerText, timerBoard, timerContainer };
}
